import { FILTER_NAMES, TABLE_NAMES } from "..";

const FILTER_LIST_FIELD_NAMES = {
    [TABLE_NAMES.Devices]: [
        FILTER_NAMES.ActivityStatus,
        FILTER_NAMES.GroupId,
        FILTER_NAMES.Model,
        FILTER_NAMES.ModelPlatform,
        FILTER_NAMES.CurrentFw,
        FILTER_NAMES.CurrentCfg,
        FILTER_NAMES.TaskQueue,
        FILTER_NAMES.SpecId
    ],
    [TABLE_NAMES.Tasks]: [
        FILTER_NAMES.TaskStatus,
        FILTER_NAMES.Type,
        FILTER_NAMES.CreatedBy,
        FILTER_NAMES.GroupId,
        FILTER_NAMES.Model,
        FILTER_NAMES.CurrentFw,
        FILTER_NAMES.CurrentCfg,
        FILTER_NAMES.Id,
        FILTER_NAMES.DeviceImei,
        FILTER_NAMES.BatchId
    ],
    [TABLE_NAMES.TaskGroups]: [FILTER_NAMES.TaskType],
    [TABLE_NAMES.DeviceGroups]: [
        FILTER_NAMES.ConfigurationFileId,
        FILTER_NAMES.FirmwareFileId
    ],
    [TABLE_NAMES.Files]: [FILTER_NAMES.Type],
    [TABLE_NAMES.Companies]: [FILTER_NAMES.AccessGroup],
    [TABLE_NAMES.Users]: [
        FILTER_NAMES.Status,
        FILTER_NAMES.RoleId,
        FILTER_NAMES.AccessGroup
    ],
    [TABLE_NAMES.Roles]: [FILTER_NAMES.Permission],
    [TABLE_NAMES.DeviceModels]: [
        FILTER_NAMES.Platform,
        FILTER_NAMES.SupportedTaskType
    ],
    [TABLE_NAMES.DeviceModelTaskCompatibilities]: [
        FILTER_NAMES.ModelName,
        FILTER_NAMES.TaskType
    ]
};

const BOOLEAN_FILTER_NAMES = {
    [TABLE_NAMES.DeviceModels]: [FILTER_NAMES.WebEditorSupport],
    [TABLE_NAMES.DeviceModelTaskCompatibilities]: [FILTER_NAMES.TaskSupport]
};

export { FILTER_LIST_FIELD_NAMES, BOOLEAN_FILTER_NAMES };
